export const ALLOWED_INPUT_KEYS = new Set([
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'Backspace',
  'Delete',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Tab',
]);

export const ALLOWED_INPUT_KEYS_WITH_DECIMAL_SEPARATOR = new Set([...ALLOWED_INPUT_KEYS, '.', ',']);
